import React, { useContext } from 'react'
import { useQuery } from 'react-query'
import { DashboardContext } from '../Context/DashboardContext'
import AuthAxios from '../utils/AuthAxios'

const banimageuser = async (id) => {
    const response = await AuthAxios?.get(`/image/ban/${id}`)
    const data = response.data.data
    return data
  }



export default function useBannedImagesApi(id) {

    const {bannedimagesdata, setbannedimagesdata} = useContext(DashboardContext);
      return useQuery('ban story', ()=> banimageuser(id), {
        refetchOnWindowFocus: false ,
        enabled: false,
        
        onSuccess: (data, message) => {
            //  console.log(data, "Baned response")
             setbannedimagesdata(data);
          },


          onError: (error)=>{
            // console.log(error, "error occured")
          }

      })
}
